import axios from 'axios';
// const mySERVER = 'https://api.publicapis.org/entries'
// const urlPrefix = process.env.REACT_APP_URL_PREFIX
// const publicUrl = process.env.PUBLIC_URL
// const URLProductsSalesForce = `${api_host}/getProducts`;
const api_host = process.env.REACT_APP_API_HOST || "https://api.mahuti.co.il";
const mySERVER = `${api_host}/getPaymentURL`;
const paySuccessUrl = `${api_host}/finalizePayment`;


const jsonIcredi = (store) => {
  const options = {
    CustomerLastName: store.customerDetails.firstName,
    CustomerFirstName: store.customerDetails.lastName,
    Address: store.customerDetails.address,
    City: store.customerDetails.city,
    EmailAddress: store.customerDetails.email,
    opportunityId: store.opportunity.id,
    orderId: store.opportunity.orderId,
    selectedActivities: store.selectedActivities,
    totalAmount: store.opportunity.amount
  }
  return options
}
//make it post and send above options- instead of hardcoded in JS
export const ConnectToIcredit = (dispatch, navigate, store) => {
  return axios.post(mySERVER, { ...jsonIcredi(store) });
}

export const paymentVerify = (PublicSaleToken) => {
  console.log('paySuccessUrl->>>> ', paySuccessUrl)
  return axios.post(paySuccessUrl, {publicSales: PublicSaleToken});
}
